<template>
    <div>
        <el-card class="box-card">
            <div class="el-card-button">
                <el-button type="primary" size="small" @click="addRecharge">添加VIP套餐</el-button>
            </div>
            <el-table
                    size="small"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="list_order"
                        label="排序">
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="标题">
                </el-table-column>
                <el-table-column
                        prop="apple_id"
                        label="苹果id">
                </el-table-column>
                <el-table-column
                        prop="day"
                        label="天数">
                </el-table-column>
                <el-table-column
                        prop="sday"
                        label="赠送天数">
                </el-table-column>
                <el-table-column
                        prop="price"
                        label="价格">
                </el-table-column>
                <el-table-column
                        prop="original_price"
                        label="原价">
                </el-table-column>
                <el-table-column
                        prop="ishot"
                        label="是否热门">
                    <template slot-scope="scope">
                        <span v-if="scope.row.ishot==0">否</span>
                        <span v-if="scope.row.ishot==1">是</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="是否启用">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0">否</span>
                        <span v-if="scope.row.status==1">是</span>
                    </template>
                </el-table-column>
                <el-table-column
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="warning" plain size="small" @click="edit(scope.row.id)">修改</el-button>
                        <el-button type="danger" plain size="small" @click="remove(scope.row.id)">删除</el-button>
                    </template>

                </el-table-column>
            </el-table>
            <el-dialog :title="fromTitle"
                       :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'90%':'50%'"
                       :visible.sync="visible">
                <el-form ref="form"
                         :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'200px'"
                         size="small">
                    <el-form-item label="标题">
                        <el-input v-model="form.title"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="苹果id">
                        <el-input v-model="form.apple_id"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="天数">
                        <el-input v-model="form.day"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="赠送天数">
                        <el-input v-model="form.sday"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input v-model="form.price"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="原价">
                        <el-input v-model="form.original_price"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="是否热门">
                        <el-select v-model="form.ishot" placeholder="请选择"
                                   :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="form.list_order"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="是否启用">
                        <el-select v-model="form.status" placeholder="请选择"
                                   :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
    import {isRealNum} from '../../utils/common'

    export default {
        name: "Comic_Release",
        data() {
            return {
                tableData: [],
                form: {
                    apple_id: '',
                    day: '',
                    sday: '',
                    price: '',
                    original_price: '',
                    ishot: '',
                    list_order: '',
                    status: '',
                    title: ''
                },
                fromTitle: '新增',
                visible: false,
                id: '',
            }
        },
        created() {
            this.getList()
        },
        methods: {
            addRecharge() {
                this.fromTitle = '新增';
                this.id = '';
                this.form = {
                    apple_id: '',
                    day: '',
                    sday: '',
                    price: '',
                    original_price: '',
                    ishot: '',
                    list_order: '',
                    status: '',
                };
                this.visible = true;
            },
            // 每页显示多少条
            changeSize(val) {
                this.params.pagesize = val;
                this.getList();
            },
            // 当前显示的页数
            changeCurrent(val) {
                this.params.pagenum = val;
                this.getList()
            },
            getList() {
                this.$axios.post("admin/vip_rule/index").then((res) => {
                    this.tableData = res.data;
                });
            },
            // 编辑用户
            edit(id) {
                this.id = id;
                this.fromTitle = '编辑';
                this.$axios.get('admin/vip_rule/' + id, {}).then((res) => {
                    let data = res.data;
                    for (let key in data) {
                        if (isRealNum(data[key])) {
                            data[key] = data[key].toString()
                        }
                    }
                    this.form = data;
                    this.visible = true;
                });
            },
            // 确认提交添加或编辑用户
            dialogAffirm() {
                if (this.id) {
                    this.$axios.put('admin/vip_rule/' + this.id, this.form).then((res) => {
                        this.$message.success('成功');
                        this.getList();
                        this.visible = false;
                    });
                } else {
                    // 添加
                    this.$axios.post('/admin/vip_rule', this.form).then((res) => {
                        this.$message.success('成功');
                        this.getList();
                        this.visible = false;
                    });
                }
            },
            remove(id) {
                this.$confirm('确定要进行操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.del('admin/vip_rule/' + id, '').then((res) => {
                        this.$message.success('删除成功!');
                        this.getList();
                    });
                }).catch(() => {

                });
            },
        }
    }
</script>

<style scoped>

</style>